import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';
import { GetLinkedAccountsInfoRequest, GetLinkedAccountsInfoResponse } from './tethers-types';
import { getHubApi } from '../general/modules/accountServiceApi/getAccountServiceApi';

export class Tethers {
    public static async getLinkedAccountsInfo(suid:string, token: string): Promise<
        GetLinkedAccountsInfoResponse|CustomJrpcErrResult
    > {
        const request: GetLinkedAccountsInfoRequest = {
            suid,
            token
        };
        const hubApi = getHubApi();

        return hubApi.getLinkedAccountsInfo(window.app.deviceIdentifier, request);
    }
}
